import React, { useState } from 'react';
import { ResponsiveImage, Modal, ImageCarousel } from '../../components';
import css from './ListingPage.module.css';

const SectionPhotosMaybe = props => {
  const {
    title,
    listing,
    handleViewPhotosClick,
    imageCarouselOpen,
    onImageCarouselClose,
    onManageDisableScrolling,
  } = props;

  const hasImages = listing.images && listing.images.length > 0;
  if (!hasImages) return null;

  const images = listing.images;
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalCount = images.length;

  const handlePrev = e => {
    e.stopPropagation();
    setCurrentIndex(prev => (prev === 0 ? totalCount - 1 : prev - 1));
  };

  const handleNext = e => {
    e.stopPropagation();
    setCurrentIndex(prev => (prev === totalCount - 1 ? 0 : prev + 1));
  };

  return (
    <div className={css.photoCarousel}>
      <div className={css.photoCarouselMain} onClick={handleViewPhotosClick}>
        <ResponsiveImage
          rootClassName={css.photoCarouselImg}
          alt={title}
          image={images[currentIndex]}
          variants={['scaled-medium', 'scaled-large', 'scaled-xlarge']}
        />
        <div className={css.photoCarouselCounter}>
          {currentIndex + 1} / {totalCount}
        </div>
      </div>

      {totalCount > 1 && (
        <>
          <button className={css.photoNavLeft} onClick={handlePrev} aria-label="Previous">&lsaquo;</button>
          <button className={css.photoNavRight} onClick={handleNext} aria-label="Next">&rsaquo;</button>
        </>
      )}

      {totalCount > 1 && (
        <div className={css.photoThumbs}>
          {images.map((img, i) => (
            <button
              key={img.id.uuid}
              className={`${css.photoThumb} ${currentIndex === i ? css.photoThumbActive : ''}`}
              onClick={() => setCurrentIndex(i)}
            >
              <ResponsiveImage
                rootClassName={css.photoThumbImg}
                alt={`${title} ${i + 1}`}
                image={img}
                variants={['scaled-small']}
              />
            </button>
          ))}
        </div>
      )}

      <Modal
        id="ListingPage.imageCarousel"
        scrollLayerClassName={css.carouselModalScrollLayer}
        containerClassName={css.carouselModalContainer}
        lightCloseButton
        isOpen={imageCarouselOpen}
        onClose={onImageCarouselClose}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <ImageCarousel
          images={listing.images}
          imageVariants={['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge']}
        />
      </Modal>
    </div>
  );
};

export default SectionPhotosMaybe;
